import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { CollectionCard, LoadingBlock } from "@/components/site/Cards";

export default function Collections() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/collections").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="collections-page">
      <section className="border-b border-oc-hairline">
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16 md:py-24">
          <div className="eyebrow text-oc-coral mb-6">Curated Reading</div>
          <h1 className="hero-headline text-5xl md:text-7xl text-oc-ink">Collections</h1>
          <p className="mt-6 font-editorial text-xl text-oc-ink-soft max-w-2xl">
            Guided reading paths rather than chronological feeds. Each collection groups the interviews that read best together.
          </p>
        </div>
      </section>
      <section>
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16 space-y-8">
          {loading ? (
            <LoadingBlock />
          ) : items.length === 0 ? (
            <div className="py-24 text-center font-editorial text-xl text-oc-ink-muted">No collections yet.</div>
          ) : (
            items.map((c) => <CollectionCard key={c.slug} collection={c} />)
          )}
        </div>
      </section>
    </div>
  );
}
